// extracted by mini-css-extract-plugin
module.exports = {"discounted":"Price_discounted__HXTmN","searchResultsPageProductCardPrice":"Price_searchResultsPageProductCardPrice__9t7eZ"};